export default "__VITE_ASSET__DpFGzXKb__"